module.exports = "/images/Left.svg?e4078d642fec61679211c925044b2b75";